import { DocumentInfo, ExtractType, Unpacked, UserProfile } from '@borg/types';
import { LanguagePatch } from '@/layers/MyProfile/types';

class UserProfileService {
  getProfile = () => serviceHttpGetFactory<UserProfile>('/me/profile');
  getProfilePublishable = () =>
    serviceHttpGetFactory<Pick<UserProfile, 'publishable'>>('/me/profile/publishable');
  patchProfile = (data: Partial<UserProfile>) =>
    serviceHttpPatchFactory<UserProfile>('/me/profile', data);
  getProfilePdf = () => serviceHttpGetFactory<DocumentInfo>('/me/profile/pdf');
  workExperience = userElementsManager<Unpacked<UserProfile['workExperience']>>('workExperience');
  volunteerExperience =
    userElementsManager<Unpacked<UserProfile['volunteerExperience']>>('volunteerExperience');
  educations = userElementsManager<Unpacked<UserProfile['educations']>>('educations');
  trainings = userElementsManager<Unpacked<UserProfile['trainings']>>('trainings');
  languages = userElementsManager<Unpacked<UserProfile['languages']>, LanguagePatch>('languages');
  driverLicences = userElementsManager<Unpacked<UserProfile['driverLicences']>>('driverLicences');
}

export const userProfileService = new UserProfileService();

type UserProfileArrays<T> = keyof ExtractType<UserProfile, T[]>;

export function userElementsManager<T, D = Partial<Omit<T, 'id'>>>(name: UserProfileArrays<T>) {
  const kebabName = name.replace(/[A-Z]/g, (m) => '-' + m.toLowerCase());
  return {
    getMany: () => serviceHttpGetFactory<T[]>(`/me/${kebabName}`),
    setMany: (data: D[]) => serviceHttpPutFactory<T[]>(`/me/${kebabName}`, data),
    getOne: (id: number | string) => serviceHttpGetFactory<T>(`/me/${kebabName}/${id}`),
    create: (data: D) => serviceHttpPostFactory<T>(`/me/${kebabName}`, data),
    update: (id: number | string, data: D) =>
      serviceHttpPutFactory<T>(`/me/${kebabName}/${id}`, data),
    delete: (id: number | string) => serviceHttpDeleteFactory(`/me/${kebabName}/${id}`),
  };
}
